import { jsx, jsxs } from "react/jsx-runtime";
import { useClassName } from "@contember/react-utils";
import { memo, useRef, useContext } from "react";
import { useRadio, useFocusRing, useHover, VisuallyHidden } from "react-aria";
import { RadioButton } from "./RadioButton.js";
import { RadioContext } from "./RadioContext.js";
import { FieldContainer } from "../FieldContainer/FieldContainer.js";
import { toEnumStateClass } from "../../../utils/toEnumStateClass.js";
import { toStateClass } from "../../../utils/toStateClass.js";
const RadioControl = memo(({ RadioButtonComponent, description, size, validationState, ...props }) => {
  const { children, value } = props;
  const ref = useRef(null);
  const state = useContext(RadioContext);
  const { isDisabled, isReadOnly } = state;
  const { inputProps } = useRadio(props, state, ref);
  const { isFocusVisible, focusProps } = useFocusRing();
  const { isHovered } = useHover({ isDisabled });
  const isSelected = state.selectedValue === value;
  const RadioButton$1 = RadioButtonComponent ?? RadioButton;
  return /* @__PURE__ */ jsx("label", { className: useClassName("radio-control", [
    toEnumStateClass(validationState),
    toStateClass("focused", isFocusVisible),
    toStateClass("checked", isSelected),
    toStateClass("indeterminate", state.selectedValue === null),
    toStateClass("disabled", isDisabled),
    toStateClass("readonly", isReadOnly),
    toStateClass("hovered", isHovered)
  ]), children: /* @__PURE__ */ jsx(
    FieldContainer,
    {
      useLabelElement: false,
      size,
      display: "inline",
      label: children,
      labelDescription: description,
      labelPosition: "right",
      children: /* @__PURE__ */ jsxs("span", { className: useClassName("radio-control-button-wrapper"), children: [
        /* @__PURE__ */ jsx(VisuallyHidden, { children: /* @__PURE__ */ jsx("input", { ...inputProps, ...focusProps, ref }) }),
        /* @__PURE__ */ jsx(
          RadioButton$1,
          {
            focused: isFocusVisible,
            checked: isSelected,
            indeterminate: value === null,
            disabled: isDisabled,
            readonly: inputProps.readOnly,
            hovered: isHovered,
            invalid: validationState === "invalid"
          }
        )
      ] })
    }
  ) });
});
RadioControl.displayName = "Radio";
export {
  RadioControl
};
//# sourceMappingURL=RadioControl.js.map
